import React from "react";
import { Button } from "./ui/Button";

interface EmptyStateProps {
  title: string;
  description: string;
  actionText?: string;
  onAction?: () => void;
  isLoading?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  actionText,
  onAction,
  isLoading = false,
}) => {
  return (
    <div className="py-16 text-center max-w-md mx-auto">
      <h2 className="text-xl font-semibold text-foreground mb-2 tracking-tight">{title}</h2>
      <p className="text-muted-foreground mb-6 leading-relaxed">{description}</p>
      {onAction && actionText && (
        <Button variant="secondary" onClick={onAction} disabled={isLoading}>
          {isLoading ? "Processando…" : actionText}
        </Button>
      )}
    </div>
  );
};

export default EmptyState;
